import { render, staticRenderFns } from "./virus.vue?vue&type=template&id=9d980b90&scoped=true"
import script from "./virus.vue?vue&type=script&lang=js"
export * from "./virus.vue?vue&type=script&lang=js"
import style0 from "./virus.vue?vue&type=style&index=0&id=9d980b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d980b90",
  null
  
)

export default component.exports